import React from 'react';
import '../../styles/style.css'

function EmptyTodos(){
    return(
        <p>Crea tu primer ToDo</p>
    );   
}
export { EmptyTodos };